module.exports = "images/zip-big.png";